import React, { forwardRef, useMemo, useRef, useState } from 'react';
import { Box } from '../Box';
import { NavbarButton } from './NavbarButton';
import { NavbarModal } from './NavbarModal';
import { NavbarContext } from './NavbarContext';
import { useComposedRefs, useElementSize } from '../../utils';
import './Navbar.css';
/**
 * The Navbar is a container component that provides a CSS Grid Layout with three columns. The
 * columns at the beginning and end take up 1 fraction of the space that is left over by the middle
 * column. The middle column is therefore always centered.
 *
 * To control the position of a component within one of the Navbar areas you can give it an inline
 * margin of `auto`. For example the common use case will be to right align the component at the far
 * end of the Navbar, so you should pass it the layout prop `marginInlineStart` with a value of
 * `auto`. The component will set the marginInline* properties to a sensible default so you don't
 * have to worry about this in most use cases.
 *
 * Navbar exports two more sub-components, `Navbar.Button` and `Navbar.Modal` that have additional
 * styling and behavior compared to their default siblings.
 */
const _Navbar = forwardRef(function Navbar(props, ref) {
    const { children, announcement, ...rest } = props;
    const navbarRef = useRef(null);
    const [height, setHeight] = useState(0);
    useElementSize(navbarRef, ({ height }) => {
        setHeight(height);
    });
    return (React.createElement(NavbarContext.Provider, { value: useMemo(() => ({ height }), [height]) },
        React.createElement(Box.Restricted, { ...rest, className: "mollie-ui-navbar", ref: useComposedRefs(ref, navbarRef) },
            announcement && (React.createElement("div", { className: "mollie-ui-navbar-announcement" }, announcement)),
            React.createElement("div", { className: "mollie-ui-navbar-menu" },
                React.createElement("div", { className: "mollie-ui-navbar-wrapper" }, children)))));
});
_Navbar.displayName = 'NavBar';
export const Navbar = Object.assign({}, _Navbar, {
    Button: NavbarButton,
    Modal: NavbarModal,
});
//# sourceMappingURL=Navbar.js.map